<template>
    <div>
        <el-form inline size="small">
            <el-form-item label="检测编号">
                <el-input v-model="searchParams.task_no" placeholder="请输入检测编号" size="small" clearable></el-input>
            </el-form-item>
            <el-form-item label="关键词">
                <el-input v-model="searchParams.remark" placeholder="请输入关键词" size="small" clearable></el-input>
            </el-form-item>
            <el-form-item label="SKU异常">
                <el-select v-model="searchParams.cloudEditSkuStatus" placeholder="请选择状态" clearable filterable multiple collapse-tags
                    style="width: 250px">
                    <el-option v-for="item in skuViolcationStatus" :key="item.value" :label="item.label" :value="item.value" />
                </el-select>
            </el-form-item>

            <!-- <el-form-item label="尺码违规">
                <el-select v-model="searchParams.sku_size_abnormal_words_check" placeholder="请选择状态" clearable
                    style="width: 120px">
                    <el-option v-for="item in check_status" :key="item.key" :label="item.value" :value="item.key" />
                </el-select>
            </el-form-item>

            <el-form-item label="高价限制">
                <el-select v-model="searchParams.sku_amount_max_limit_check" placeholder="请选择状态" clearable
                    style="width: 120px">
                    <el-option v-for="item in check_status" :key="item.key" :label="item.value" :value="item.key" />
                </el-select>
            </el-form-item>

            <el-form-item label="低价限制">
                <el-select v-model="searchParams.sku_amount_min_limit_check" placeholder="请选择状态" clearable
                    style="width: 120px">
                    <el-option v-for="item in check_status" :key="item.key" :label="item.value" :value="item.key" />
                </el-select>
            </el-form-item>

            <el-form-item label="价格倍数差">
                <el-select v-model="searchParams.sku_amount_max_min_gap_check" placeholder="请选择状态" clearable
                    style="width: 120px">
                    <el-option v-for="item in check_status" :key="item.key" :label="item.value" :value="item.key" />
                </el-select>
            </el-form-item>

            <el-form-item label="价格差">
                <el-select v-model="searchParams.sku_amount_max_min_gapmoney_check" placeholder="请选择状态" clearable
                    style="width: 120px">
                    <el-option v-for="item in check_status" :key="item.key" :label="item.value" :value="item.key" />
                </el-select>
            </el-form-item>

            <el-form-item label="价格违规">
                <el-select v-model="searchParams.sku_amount_abnormal_check" placeholder="请选择状态" clearable
                    style="width: 120px">
                    <el-option v-for="item in check_status" :key="item.key" :label="item.value" :value="item.key" />
                </el-select>
            </el-form-item> -->

            <el-form-item label="状态">
                <el-select v-model="searchParams.status" placeholder="请选择状态" clearable style="width: 100px">
                    <el-option v-for="item in process_status" :key="item.key" :label="item.value" :value="item.key" />
                </el-select>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" size="small" @click="handleSearch">查询</el-button>
                <el-button size="small" @click="refresh">重置</el-button>
            </el-form-item>
        </el-form>
        <div style="margin-bottom: 15px;">
            <!-- <el-select
                v-model="searchParams.name_words"
                multiple
                filterable
                clearable
                collapse-tags
                size="small"
                style="width: 160px;"
                placeholder="关键词违规"
                @clear="change_search"
                @visible-change="change_search"
            >
                <el-option
                    v-for="item in name_words_options"
                    :key="item"
                    :label="item"
                    :value="item"
                    >
                {{ item }}
                </el-option>
            </el-select>
            <el-select
                v-model="searchParams.size_words"
                multiple
                filterable
                clearable
                collapse-tags
                size="small"
                style="width: 160px;margin: 0 8px 0 8px;"
                placeholder="尺码违规"
                @clear="change_search"
                @visible-change="change_search"
            >
                <el-option
                    v-for="item in size_words_options"
                    :key="item"
                    :label="item"
                    :value="item"
                    >
                {{ item }}
                </el-option>
             </el-select> -->
            <el-button type="primary" plain size="small" @click="replaceSkuName">一键过滤</el-button>
            <el-button type="primary" plain size="small" @click="batchDelete">批量删除异常SKU</el-button>
            <el-button type="primary" plain size="small" @click="handleCloudBatchEdit">批量编辑</el-button>
            <el-button type="primary" plain size="small" @click="batchoffline">批量下架</el-button>
            <!-- <el-button type="success" size="small" @click="handleAdd">批量新增</el-button> -->
        </div>
        <el-table v-loading="loading" :data="tableData" @selection-change="selectChange"
            :header-cell-style="{ background: '#eef1f6', color: '#606266' }" class="rc_table" row-key="id">
            <el-table-column type="selection" align="center" width="50"></el-table-column>
            <el-table-column label="序号" type="index" align="center" width="50"></el-table-column>
            <el-table-column label="商品信息" min-width="220">
                <template #default="{ row }">
                    <div class="goods-box">
                        <img :src="row.import_product.main_image" class="goods-img">
                        <div class="goods-info">
                            <el-tooltip class="item" effect="dark" :content="row.import_product.title" placement="top"
                                :open-delay="300">
                                <div class="goods-title">{{ row.import_product.title }}</div>
                            </el-tooltip>
                            <div>价格：{{ row.import_product.price }}</div>
                            <div>来源ID：{{ row.import_product.source_product_id }}</div>
                            <div :class="skuStatus[row.import_product.sku_status].type">
                                {{ skuStatus[row.import_product.sku_status].label }}<span
                                    v-if="row.import_product.status === 4" class="offline-tag"> | 已下架</span></div>
                        </div>
                    </div>
                </template>
            </el-table-column>
            <el-table-column label="检测编号" prop="task_no" align="center" width="120"
                show-overflow-tooltip></el-table-column>
            <el-table-column label="商品编号" prop="product_id" width="80" show-overflow-tooltip
                align="center"></el-table-column>
            <el-table-column label="关键词违规" align="center" show-overflow-tooltip>
                <template #default="{ row }">
                    <el-tag size="small"
                        :type="check_status.find(s => s.key === row.sku_name_abnormal_words_check)?.type">
                        {{check_status.find(s => s.key === row.sku_name_abnormal_words_check)?.value}}
                    </el-tag>
                </template>
            </el-table-column>
            <el-table-column label="尺码违规" align="center" show-overflow-tooltip>
                <template #default="{ row }">
                    <el-tag size="small"
                        :type="check_status.find(s => s.key === row.sku_size_abnormal_words_check || s.key === 9)?.type">
                        {{check_status.find(s => s.key === row.sku_size_abnormal_words_check || s.key === 9)?.value}}
                    </el-tag>
                </template>
            </el-table-column>
            <el-table-column label="高价限制" align="center" show-overflow-tooltip>
                <template #default="{ row }">
                    <el-tag size="small" :type="check_status.find(s => s.key === row.sku_amount_max_limit_check)?.type">
                        {{check_status.find(s => s.key === row.sku_amount_max_limit_check)?.value}}
                    </el-tag>
                </template>
            </el-table-column>
            <el-table-column label="低价限制" align="center" show-overflow-tooltip>
                <template #default="{ row }">
                    <el-tag size="small" :type="check_status.find(s => s.key === row.sku_amount_min_limit_check)?.type">
                        {{check_status.find(s => s.key === row.sku_amount_min_limit_check)?.value}}
                    </el-tag>
                </template>
            </el-table-column>
            <el-table-column label="价格倍数差" align="center" show-overflow-tooltip>
                <template #default="{ row }">
                    <el-tag size="small"
                        :type="check_status.find(s => s.key === row.sku_amount_max_min_gap_check)?.type">
                        {{check_status.find(s => s.key === row.sku_amount_max_min_gap_check)?.value}}
                    </el-tag>
                </template>
            </el-table-column>
            <el-table-column label="价格差" align="center" show-overflow-tooltip>
                <template #default="{ row }">
                    <el-tag size="small"
                        :type="check_status.find(s => s.key === row.sku_amount_max_min_gapmoney_check)?.type">
                        {{check_status.find(s => s.key === row.sku_amount_max_min_gapmoney_check)?.value}}
                    </el-tag>
                </template>
            </el-table-column>
            <el-table-column label="价格违规" align="center" show-overflow-tooltip>
                <template #default="{ row }">
                    <el-tag size="small" :type="check_status.find(s => s.key === row.sku_amount_abnormal_check)?.type">
                        {{check_status.find(s => s.key === row.sku_amount_abnormal_check)?.value}}
                    </el-tag>
                </template>
            </el-table-column>
            <el-table-column label="异常记录" width="150" align="center">
                <template #default="{ row }">
                    <!-- 关键：把 content 换成 html 插槽！ -->
                    <el-tooltip effect="dark" placement="top" :open-delay="300">
                        <!-- 表格内显示 3行，每行10字 -->
                        <div class="remark-multi-line">
                            <div v-for="(text, index) in formatRemark(row.remark, row.sku_amount_abnormal_remark)"
                                :key="index" v-if="index < 3">
                                {{ index + 1 }}. {{ text.length > 10 ? text.slice(0, 10) + '...' : text }}
                            </div>
                        </div>
                        <div slot="content" style="white-space: pre-line; text-align:left;">
                            <div v-for="(text, index) in formatRemark(row.remark, row.sku_amount_abnormal_remark)"
                                :key="index">
                                {{ index + 1 }}. {{ text }}
                            </div>
                        </div>
                    </el-tooltip>
                </template>
            </el-table-column>
            <el-table-column label="状态" align="center" show-overflow-tooltip>
                <template #default="{ row }">
                    <el-tag size="small" :type="process_status.find(s => s.key === row.status)?.type">
                        {{process_status.find(s => s.key === row.status)?.value}}
                    </el-tag>
                </template>
            </el-table-column>
            <el-table-column label="创建时间" width="100" prop="created_at" show-overflow-tooltip
                align="center"></el-table-column>
            <el-table-column label="操作" align="center" width="80">
                <template #default="{ row }">
                    <el-button size="mini" type="primary" @click="handleEdit(row)">编辑</el-button>
                </template>
            </el-table-column>
            <!-- <el-table-column label="操作" align="center">
        <template #default="{ row }">
          <el-button size="small" @click="view_info(row)">查看策略</el-button>
          <el-button size="small" @click="view_info(row)">查看异常</el-button>
        </template>
      </el-table-column> -->
        </el-table>

        <Pagination :total="page_data.total" :page.sync="page_data.page" :limit.sync="page_data.limit" :pageSizes="[10, 20, 50, 100, 200,500,1000]"
            @pagination="getDataList" layout="total, sizes, prev, pager, next, jumper" v-if="page_data.total > 0" />

        <!-- 弹窗组件，传递API、全局提示、同步变量 -->
        <SKUEditDialog :visible.sync="cloudEditShow" :cloud-edit-mode="cloudEditMode" :cloud-edit-list="cloudEditList"
            :cloud-edit-source-list="cloudEditSourceList"/>

    </div>
</template>
<script>
import { mapActions } from "vuex";

import Pagination from "@/components/pagination/pagination.vue";
import { getViolationWords } from "../../api/main/ucenter";
import SKUEditDialog from "./skuEditDialog.vue";
export default {
    components: {
        Pagination, SKUEditDialog,
    },
    data() {
        return {
            selectedValues: [],
            name_words_options: [],
            size_words_options: [],
            dataInfo: {},
            tableData: [],
            skuCheckInfo: {},
            skuStatus: {
                1: { label: '待替换', value: 1, type: 'selected-tag' },
                2: { label: '已替换', value: 2, type: 'replaced-tag' },
                3: { label: '找不到', value: 3, type: 'notFond-tag' }
            },
            skuViolcationStatus: {
                1: { label: '关键词违规', value: 1, type: 'selected-tag' },
                2: { label: '尺码违规', value: 2, type: 'replaced-tag' },
                3: { label: '高价限制', value: 3, type: 'notFond-tag' },
                4: { label: '低价限制', value: 4, type: 'notFond-tag' },
                5: { label: '价格倍数差', value: 5, type: 'notFond-tag' },
                6: { label: '价格差', value: 6, type: 'notFond-tag' },
                //7: { label: '配件/耗材混卖', value: 7, type: 'notFond-tag' },
                //8: { label: '非商品SKU', value: 8, type: 'notFond-tag' },
                //9: { label: '异常拆分规格', value: 9, type: 'notFond-tag' },
                10: { label: '套装和单件混卖', value: 10, type: 'notFond-tag' },
                //11: { label: '孤立低价SKU', value: 11, type: 'notFond-tag' },
                12: { label: '低价SKU引流', value: 12, type: 'notFond-tag' },
                //13: { label: '铺货价与最低铺货价不一致。', value: 13, type: 'notFond-tag' },
                // 19: { label: '完成整改', value: 19, type: 'notFond-tag' },
            },
            check_status: [
                { key: 1, value: '正常', type: 'success' },
                { key: 2, value: '异常', type: 'danger' },
                { key: 9, value: '不检测', type: 'info' },
            ],
            process_status: [
                { key: 1, value: '待处理', type: 'danger' },
                { key: 2, value: '已处理', type: 'success' },
                { key: 9, value: '处理异常', type: 'danger' },
            ],
            page_data: {
                limit: 10,
                page: 1,
                total: 0,
            },
            searchParams: {
                task_no: '',
                name_words: '',
                size_words: '',
                // sku_name_abnormal_words_check: '',
                // sku_amount_max_limit_check: '',
                // sku_amount_min_limit_check: '',
                // sku_amount_max_min_gap_check: '',
                // sku_amount_max_min_gapmoney_check: '',
                // sku_amount_abnormal_check: '',
                cloudEditSkuStatus:[],
                remark: '',
                status: '',
            },
            selectData: [],
            loading: false,
            cloudEditShow: false,
            cloudEditMode: 'single',
            cloudEditList: [],
            cloudEditSourceList: [],
        }
    },
    created() {
        // this.initData()
    },
    mounted() {
        this.searchParams.task_no = this.$route.query.task_no
        if (this.searchParams.task_no) {
            this.handleSearch()
        }
        // this.getViolationWords()
    },
    methods: {
        ...mapActions({
            opGetSkudetectionDetailPage: 'ucenter/opGetSkudetectionDetailPage',
            opDelSkudetectionDetail: 'ucenter/opDelSkudetectionDetail',
            opOfflineSkudetection: 'ucenter/opOfflineSkudetection',
            opGetViolationWords: 'ucenter/opGetViolationWords',
            opPutReplaceSkuName: 'ucenter/opPutReplaceSkuName',
        }),
        initData(task_no) {
            if (task_no) {
                this.searchParams.task_no = task_no
                this.handleSearch()
            } else {
                this.refresh()
            }

        },
        refresh() {
            this.page_data.page = 1
            this.page_data.total = 0
            this.searchParams = {
                task_no: '',
                name_words: '',
                size_words: '',
                // sku_name_abnormal_words_check: '',
                // sku_size_abnormal_words_check: '',
                // sku_amount_max_limit_check: '',
                // sku_amount_min_limit_check: '',
                // sku_amount_max_min_gap_check: '',
                // sku_amount_max_min_gapmoney_check: '',
                // sku_amount_abnormal_check: '',
                cloudEditSkuStatus:[],
                remark: '',
                status: '',
            }
            this.getDataList()
        },
        handleSearch() {
            this.page_data.page = 1
            this.getDataList()
        },
        selectChange(e) {
            this.selectData = [...e]
        },
        //获取检测列表
        getDataList() {
            this.loading = true
            let param = { page_size: this.page_data.limit, page: this.page_data.page, ...this.searchParams }
            this.opGetSkudetectionDetailPage({
                data: param,
                success: (res) => {
                    this.loading = false
                    // console.log(res)
                    if (res.code == 200) {
                        this.tableData = res.data.list
                        this.page_data.total = res.data.total
                    } else {
                        this.$message.error(res.message)
                    }

                }
            })
        },
        //批量删除
        batchDelete() {
            if (this.selectData.length == 0 && this.searchParams.task_no == '') {
                this.$message.error('请选择异常sku信息，或填写检测编号');
                return
            }
            let messagetitle = `是否确定删除${this.selectData.length}个异常sku?`
            if (this.selectData.length == 0 && this.searchParams.task_no != '') {
                messagetitle = `检测编号:${this.searchParams.task_no},将批量删除全部异常sku`
            }

            this.$confirm(messagetitle, '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.opDelSkudetectionDetail({
                    data: { ids: this.selectData.map(item => item.id).join(','), task_no: this.searchParams.task_no },
                    success: (res) => {
                        if (res.code == 200) {
                            this.$message.success('删除成功，' + res.data + 'sku')
                            this.getDataList()
                        } else {
                            this.$message.error(res.message)
                        }
                    }
                })
            })
        },
        //批量删除
        replaceSkuName() {
            if (this.selectData.length == 0 && this.searchParams.task_no == '') {
                this.$message.error('请选择异常sku信息，或填写检测编号');
                return
            }
            let messagetitle = `是否确定过滤${this.selectData.length}个异常sku?`
            if (this.selectData.length == 0 && this.searchParams.task_no != '') {
                messagetitle = `检测编号:${this.searchParams.task_no},将批量过滤全部异常sku`
            }

            this.$confirm(messagetitle, '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.opPutReplaceSkuName({
                    data: { ids: this.selectData.map(item => item.id).join(','), task_no: this.searchParams.task_no },
                    success: (res) => {
                        if (res.code == 200) {
                            this.$message.success('过滤成功，' + res.data + 'sku')
                            this.getDataList()
                        } else {
                            this.$message.error(res.message)
                        }
                    }
                })
            })
        },
        //批量下架
        batchoffline() {
            if (this.selectData.length == 0) {
                this.$message.error('请选择下架商品');
                return
            }
            let messagetitle = `是否确定下架${this.selectData.length}个异常sku的云商品?`
            this.$confirm(messagetitle, '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.opOfflineSkudetection({
                    data: { ids: this.selectData.map(item => item.id).join(',') },
                    success: (res) => {
                        if (res.code == 200) {
                            this.$message.success('下架成功，' + res.data + '个商品')
                            this.getDataList()
                        } else {
                            this.$message.error(res.message)
                        }
                    }
                })
            })
        },
        // 切割 | 成数组
        formatRemark(remark, sku_amount_abnormal_remark) {
            // 两个都为空直接返回空数组
            if (!remark && !sku_amount_abnormal_remark) return []

            let appendStr = ''
            if (sku_amount_abnormal_remark) {
                try {
                    // 解析JSON数组
                    const list = JSON.parse(sku_amount_abnormal_remark)
                    const arr = []
                    for (const item of list) {
                        // 拼接指定字段
                        // const text = `SKU_ID:${item.SKU_ID},SKU规格:${item["SKU规格"]},官方风险分类:${item["官方风险分类"]},违规原因:${item["违规原因"]},混卖信号:${item["混卖信号"]}`
                        const text = `SKU_ID:${item.SKU_ID},违规原因:${item["违规原因"]}`
                        arr.push(text)
                    }
                    appendStr = arr.join('|')
                } catch (e) {
                    // JSON解析失败不追加内容
                    appendStr = ''
                }
            }

            // 合并原有remark和异常备注
            const temp = []
            if (remark) temp.push(remark.trim())
            if (appendStr) temp.push(appendStr)
            const fullRemark = temp.join('|')

            // 分割、过滤空项返回
            return fullRemark.split('|').filter(item => item.trim() !== '')
        },
        getViolationWords() {
            this.opGetViolationWords({
                data: {},
                success: (res) => {
                    if (res.code == 200) {
                        this.name_words_options = res.data.sku_name_abnormal_words
                        this.size_words_options = res.data.sku_size_abnormal_words
                    } else {
                        this.$message.error(res.message)
                    }
                }
            })
        },
        // 失去焦点查询
        change_search(change) {
            if (!change) {
                // 加个延时 200ms，防止连续触发
                clearTimeout(this.blurTimer)
                this.blurTimer = setTimeout(() => {
                    this.getDataList() // 执行你的查询接口
                }, 200)
            }

        },
        // 打开单条编辑
        handleEdit(row) {
            this.cloudEditMode = 'single'
            this.cloudEditList = [row]
            this.cloudEditShow = true
        },
        // 打开批量编辑
        handleCloudBatchEdit() {
            this.cloudEditMode = 'batch'
            this.cloudEditList = [...this.selectData]
            this.cloudEditShow = true
        },
        // 关闭弹窗重置数据
        handleCloudEditClose() {
            this.cloudEditDirty = false
            this.cloudEditMode = 'single'
            this.cloudEditList = []
            this.cloudEditShow = false
        },

    }
}
</script>


<style scoped>
.w_120 {
    width: 150px;
}

.text-ellipsis-multi {
    line-height: 1.4;
    max-height: 60px;
    overflow: hidden;
    text-align: left;
}

/* 商品信息样式 */
.goods-box {
    display: flex;
    align-items: flex-start;
    width: 100%;
    /*max-width: 280px;*/
    /* 限制最大宽度 */
    flex: 1;
}

.goods-img {
    width: 50px;
    height: 50px;
    object-fit: cover;
    margin-right: 8px;
    border-radius: 4px;
    flex-shrink: 0;
    /* 防止图片被压缩 */
}

.goods-info {
    flex: 1;
    font-size: 12px;
    line-height: 1.5;
    min-width: 0;
    /* 允许内容收缩 */
    overflow: hidden;
}

.goods-info>div {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    margin-bottom: 2px;
}

.goods-title {
    font-size: 13px;
    font-weight: 500;
    color: #333;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    white-space: normal;
    /* 标题允许换行 */
    margin-bottom: 4px;
}


.notFond-tag {
    color: #999999;
    font-size: 10px;
    margin-top: 2px;
}

.selected-tag {
    color: #E6A23C;
    font-size: 10px;
    margin-top: 2px;
}

.offline-tag {
    color: #e71b1b;
    font-size: 10px;
    margin-top: 2px;
}

.replaced-tag {
    color: #67c23a;
    font-size: 10px;
    margin-top: 2px;
    font-weight: bold;
}

.remark-multi-line {
    text-align: left;
    line-height: 1.5;
    max-height: 4.5em;
    /* 刚好3行 */
    overflow: hidden;
}

.remark-multi-line>div {
    white-space: nowrap;
    overflow: hidden;
}

::v-deep .el-select__tags {
    flex-wrap: nowrap !important;
    /* 不换行 */
}

::v-deep .el-select__tags-text {
    display: inline-block;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

::v-deep .el-select__input {
    width: auto !important;
    min-width: 30px !important;
}
</style>
